import React, { useState } from 'react';
import { ColumnDefinition } from '../../../../../models';
import { groupPivotRows } from '../../../../functions/pivotRows';
import DataRows, { cellClassName, renderCell } from './DataRows';

interface GroupedRowsProps {
  data: Record<string, any>[];
  columns: ColumnDefinition[];
  groupColumns: ColumnDefinition[];
}

const GroupedRows: React.FC<GroupedRowsProps> = ({
  data,
  columns,
  groupColumns,
}) => {
  const [collapsedKeys, setCollapsedKeys] = useState<Set<string>>(new Set());
  const visibleColumns = columns.filter(column => column.show);
  const groups = groupPivotRows(
    data,
    groupColumns.map(column => String(column.field))
  );

  const toggle = (key: string) =>
    setCollapsedKeys(previous => {
      const next = new Set(previous);
      if (!next.delete(key)) next.add(key);
      return next;
    });

  return (
    <>
      {groups.map(group => {
        const isCollapsed = collapsedKeys.has(group.key);
        return (
          <React.Fragment key={group.key}>
            <tr className="pivot-group-header">
              <td colSpan={visibleColumns.length}>
                <button
                  type="button"
                  className="pivot-group-toggle"
                  aria-expanded={!isCollapsed}
                  onClick={() => toggle(group.key)}
                >
                  {isCollapsed ? '⊞' : '⊟'}{' '}
                  {groupColumns.map((column, index) => (
                    <React.Fragment key={String(column.field)}>
                      {index > 0 && ' · '}
                      {renderCell(column, group.firstRow)}
                    </React.Fragment>
                  ))}
                </button>
              </td>
            </tr>
            {!isCollapsed && <DataRows data={group.rows} columns={columns} />}
            {group.subtotal && (
              <tr className="pivot-subtotal">
                {visibleColumns.map((column, index) => (
                  <td key={String(column.field)} className={cellClassName(column)}>
                    {index === 0 ? 'Total' : renderCell(column, group.subtotal)}
                  </td>
                ))}
              </tr>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default GroupedRows;
